import axios from 'axios'

const INFLIGHT = new Map()
const DONE_PREFIX = 'wx_official_oauth_done_'

/** 公众号 OAuth state（base64 站内路径） */
export function decodeWechatOfficialRedirectPath(state) {
  if (!state) return ''
  try {
    const base64 = state.replace(/-/g, '+').replace(/_/g, '/')
    const padded = base64 + '='.repeat((4 - (base64.length % 4)) % 4)
    const path = atob(padded)
    if (path.startsWith('/') && !path.startsWith('//')) {
      return path
    }
  } catch {
    // ignore
  }
  return ''
}

/** 匿名测评 base 登录：enc.sig 签名 state */
export function isSignedWxOAuthState(state) {
  if (!state || !state.includes('.')) return false
  const parts = state.split('.')
  return parts.length === 2 && parts[0].length > 8 && parts[1].length > 8
}

function readCachedExchange(code) {
  try {
    const raw = sessionStorage.getItem(DONE_PREFIX + code)
    return raw ? JSON.parse(raw) : null
  } catch {
    return null
  }
}

function cacheExchange(code, result) {
  try {
    sessionStorage.setItem(DONE_PREFIX + code, JSON.stringify(result))
  } catch {
    // ignore quota errors
  }
}

/**
 * 用 code 换登录信息；同一 code 并发/重复调用只发一次请求。
 */
export async function exchangeOfficialOAuthCode(code, state) {
  const cached = readCachedExchange(code)
  if (cached?.loginData?.accessToken) {
    return cached
  }

  if (INFLIGHT.has(code)) {
    return INFLIGHT.get(code)
  }

  const task = (async () => {
    const response = await axios.get('/api/v1/wechat/official/callback', {
      params: { code, state }
    })
    const body = response.data
    if (body?.code !== 200 || !body?.data?.loginData?.accessToken) {
      const msg = body?.message || body?.info || '微信登录失败，请重新点击登录'
      const err = new Error(msg)
      if ((msg || '').includes('code been used') || (msg || '').includes('invalid code')) {
        err.code = 'oauth_code_used'
      }
      throw err
    }
    const result = {
      loginData: {
        ...body.data.loginData,
        couponBindStatus: body.data.couponBindStatus,
        couponBindMessage: body.data.couponBindMessage
      },
      redirectURL: body.data.redirectURL || decodeWechatOfficialRedirectPath(state) || '/',
      couponBindStatus: body.data.couponBindStatus,
      couponBindMessage: body.data.couponBindMessage
    }
    cacheExchange(code, result)
    return result
  })()

  INFLIGHT.set(code, task)
  try {
    return await task
  } finally {
    INFLIGHT.delete(code)
  }
}
